import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'semantic-ui-react'

const UpdateNotifierView = ({ updateAvailable }) => (
  <div
    className={`update-version-notification${updateAvailable ? ' visible' : ''}`}
  >
    <Card>
      There is a new version available.{' '}
      <a
        onClick={() => window.location.reload()}
        data-testid='update-notifier-btn'
      >
        Update Now
      </a>
    </Card>
  </div>
)

UpdateNotifierView.propTypes = {
  updateAvailable: PropTypes.bool.isRequired,
}

export default UpdateNotifierView
